export default "/images/expiries.png?698f243734d579eb48e14302d3d5914d";